import { AppUser } from "../interfaces/IUsers";
import { createContext, useContext, useEffect } from "react";
import { useUser } from "../hooks/useUser";
interface UserContextType {
  user: AppUser | null;
  isLoading: boolean;
  updateUser: (updatedUser: AppUser) => Promise<{ success: boolean; error?: string }>;
  refreshUser: () => Promise<void>;
}

export const UserContext = createContext<UserContextType | undefined>(undefined);

export default function UserProvider({ userId, children }: { userId: string; children: any }) {
  const { user, isLoading, updateUser, refreshUser } = useUser(userId);

  // Walidacja spójności: sprawdź czy user.id odpowiada userId
  useEffect(() => {
    if (user && user.id !== userId) {
      console.warn(
        `🚨 [UserContext] Niekonsystencja danych: user.id (${user.id}) !== userId (${userId})`
      );
      // W przypadku niekonsystencji, odśwież dane użytkownika
      refreshUser();
    }
  }, [user, userId, refreshUser]);

  return (
    <UserContext.Provider value={{ user, isLoading, updateUser, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUserContext = (): UserContextType => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("Błąd w UserContext: useUserContext must be used within a UserProvider.");
  }
  return context;
};
